<template>
  <div class="horizon-container bg-f3f4f7 h-100">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">报表分类</div>
      </div>
      <div class="flex-1 h-0" v-if="menuList && menuList.length">
        <cate-menu :not-operate="true" :menu-data="menuList" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 h-100 flex-column ptb-10 pr-20 pl-10" v-if="menuList && menuList.length">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-46b8b0"></span>
            {{currentClassify.name}}
          </div>
        </div>
        <!--<div class="my-picker">-->
          <!--<el-date-picker-->
            <!--v-model="dataInfo"-->
            <!--type="daterange"-->
            <!--align="right"-->
            <!--unlink-panels-->
            <!--format="yyyy 年 MM 月 dd 日"-->
            <!--value-format="yyyy-MM-dd"-->
            <!--@change="onDateChange"-->
            <!--range-separator="至"-->
            <!--start-placeholder="开始日期"-->
            <!--end-placeholder="结束日期"-->
            <!--:picker-options="pickerOptions">-->
          <!--</el-date-picker>-->
        <!--</div>-->
        <!--<div class="flex ml-10">-->
          <!--<div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">-->
            <!--<img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">-->
            <!--<el-input type="text" placeholder="输入关键字" v-model="keyword" clearable></el-input>-->
          <!--</div>-->
          <!--<button class="btn-30-bg-46b8b0" @click="getReportData">搜索</button>-->
        <!--</div>-->
      </div>
      <div class="flex align-center mb-10 flex-wrap">
        <div class="btn-30-bg-82b925-big mr-10" @click="webapp({})">打印预览</div>
        <div class="btn-30-bg-46b8b0 mr-10" @click="webapp({'type':'print'})">打印</div>
        <div class="btn-30-border-30313a mr-10" @click="webapp({'type':'print', 'showOptionDlg': 'false'})">直接打印</div>
        <div class="btn-30-border-46b8b0-s mr-10" @click="webapp({'type':'pdf'})">导出PDF</div>
        <div class="btn-30-bg-82b925-big mr-10" @click="webapp({'type':'xls'})">导出Excel</div>
        <div class="btn-30-bg-46b8b0 mr-10" @click="webapp({'type':'rtf'})">导出RTF</div>
        <div class="btn-30-border-46b8b0-s mr-10" @click="webapp({'type':'csv'})">导出CSV</div>
        <div class="btn-30-border-30313a mr-10" @click="webapp({'type':'txt'})">导出文本</div>
        <div class="btn-30-bg-46b8b0 mr-10" @click="webapp({'type':'img'})">导出图像</div>
        <div class="btn-30-bg-82b925-big mr-10" @click="webapp({'type':'grd'})">生成报表文档</div>
      </div>
      <div class="flex-1 h-0">
        <el-scrollbar class="h-100 hide-x">
          <div class="h-100">
            <div class="p-20">
              <div id="report_holder">
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="flex-1 flex-column align-center justify-center" v-else>
      <img src="/static/images/tip.png" style="width: 50px;height: 50px;margin-bottom: 20px;" alt="">
      <div class="font-12-ff5555">暂时还没有报表数据</div>
    </div>
  </div>
</template>

<script>
import CateMenu from '@/components/CateMenu'
import ErpTable from '@/components/ErpTable'
import MoveHorizon from '@/components/MoveHorizon'
import Grh from '@/utils/grhtml5-6.8-min.js'
import reportApi from '@/utils/grwebapp.js'
import axiosx from 'axios'
export default {
  name: 'Report',
  components: {CateMenu, ErpTable, MoveHorizon},
  props: ['classifyId', 'id', 'orderDefineId'], // 5单据 6收付款 7预算 8合同
  data () {
    return {
      reportViewer: null,
      data: '',
      sqlStatement: '',
      chooseMenuId: 1,
      menuList: [],
      currentClassify: {},
      dataInfo: '',
      starttime: '',
      endtime: '',
      keyword: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created () {
    this.getReportClassify()
    this.reportViewer = Grh.rubylong.grhtml5.insertReportViewer('report_holder')
    this.reportViewer.reportPrepared = false
    this.reportViewer.dataPrepared = false
  },
  mounted () {},
  methods: {
    webapp (args) {
      args.scripts = [{
        event: 'Initialize'
      }]
      args.report = this.currentClassify.grf
      args.data = this.reportViewer.dataText
      reportApi.webapp_ws_ajax_run(args)
    },
    getReportData () {
      let that = this
      let params = {
        querySql: that.sqlStatement,
        keyword: that.keyword,
        endtime: that.endtime,
        starttime: that.starttime,
        id: this.id
      }
      if (that.sqlStatement != null && that.sqlStatement !== '') {
        that.axios.post('report/getReportData', that.qs.stringify(params)).then(res => {
          that.data = res.data
          that.reportViewer.loadData(res.data)
          that.reportViewer.start()
          reportApi.webapp_urlprotocol_startup()
        })
      }
    },
    onDateChange (e) {
      this.starttime = e[0]
      this.endtime = e[0]
      this.getReportData()
    },
    getReport () {
      // let that = this
      if (!this.currentClassify.grf) {
        this.$message({
          message: '该报表还没有模板！',
          type: 'warning',
          offset: 400
        })
        return
      }
      axiosx({
        method: 'get',
        url: this.currentClassify.grf,
        headers: {
          'type': this.type,
          'token': this.token
        },
        params: {}
      }).then(res => {
        this.reportViewer.loadReport(res.data)
        this.sqlStatement = this.reportViewer.report.RunningDetailGrid.Recordset.QuerySQL
        this.getReportData()
      })
      // this.reportViewer.loadReport(this.currentClassify.grf)
      // this.getReportData()
      // this.axios.post('report/getGrf', this.qs.stringify({grf: this.currentClassify.grf})).then(res => {
      //   if (res.data.success) {
      //     let jsonObj = that.evil('(' + res.data.data + ')')
      //     // let jsonObj = ' + res.data.data + '
      //     let reportSource = JSON.stringify(jsonObj)
      //     that.reportViewer.loadReport(reportSource)
      //     that.sqlStatement = jsonObj.DetailGrid.Recordset.QuerySQL
      //     that.getReportData()
      //   } else {
      //     this.$message({
      //       message: res.data.msg,
      //       type: 'error',
      //       offset: 400
      //     })
      //   }
      // })
    },
    getReportClassify () {
      this.axios.post('report/list', {classifyId: this.classifyId, companyId: this.$store.state.companyId, orderDefineId: this.orderDefineId}).then(res => {
        if (res.data.success) {
          this.menuList = res.data.data
          this.getDefaultId(this.menuList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (!menu.children || menu.length === 0) {
        if (menu.id !== this.chooseMenuId) {
          this.chooseMenuId = menu.id
          this.currentClassify = menu
          if (this.reportViewer) {
            this.reportViewer.stop(false, false)
          }
          this.getReport()
        }
      }
    },
    getDefaultId (list) {
      if (list && list.length) {
        let data = list[0]
        if (data.children && data.children.length) {
          this.getDefaultId(data.children)
        } else {
          this.chooseMenuId = data.id
          this.currentClassify = data
          this.getReport()
        }
      }
    },
    evil (fn) {
      var Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
      return new Fn('return ' + fn)()
    }
  }
}
</script>

<style lang="scss" scoped>
  .horizon-container {
    /*height: 526px;*/
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #46b8b0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Report.vue